import withT from "neetocommons/react-utils/withT";
import { Delete } from "neetoicons";
import { Button } from "neetoui";
import { Input, Select } from "neetoui/formik";

import { ADDRESS_TYPE_SELECT_OPTIONS } from "../constants";

const AllowedIpRange = withT(({ t, index, arrayHelpers }) => (
  <div className="flex items-start gap-3">
    <div className="grid flex-grow grid-cols-1 gap-3 md:grid-cols-3">
      <Input
        className="text-start"
        data-testid="ip-start-text-field"
        label={t("neetoMolecules.ipRestriction.ipStart")}
        labelProps={{ className: "md:hidden" }}
        name={`allowedIpRanges.${index}.ipStart`}
        placeholder={t("neetoMolecules.ipRestriction.ipStart")}
      />
      <Input
        className="text-start"
        data-testid="ip-end-text-field"
        label={t("neetoMolecules.ipRestriction.ipEnd")}
        labelProps={{ className: "md:hidden" }}
        name={`allowedIpRanges.${index}.ipEnd`}
        placeholder={t("neetoMolecules.ipRestriction.ipEnd")}
      />
      <Select
        className="text-start"
        data-testid="address-type-select-field"
        label={t("neetoMolecules.ipRestriction.type")}
        labelProps={{ className: "md:hidden" }}
        name={`allowedIpRanges.${index}.addressType`}
        options={ADDRESS_TYPE_SELECT_OPTIONS}
      />
    </div>
    <div className="flex flex-shrink-0 justify-center md:min-w-14">
      <Button
        className="mt-5 md:mt-0"
        data-testid="allowed-ip-range-delete-button"
        icon={Delete}
        style="text"
        tooltipProps={{
          content: t("neetoMolecules.common.actions.discard"),
          position: "top",
          touch: ["hold", 500],
        }}
        onClick={() => arrayHelpers.remove(index)}
      />
    </div>
  </div>
));

export default AllowedIpRange;
